import {API} from 'aws-amplify';

// @ts-ignore
export const create = async (post) => API.put('robinhoodEngModeratorApi', `/likes/${post.id}`, {});

// @ts-ignore
export const del = async (post) => API.del('robinhoodEngModeratorApi', `/likes/${post.id}`, {});
